module.exports = __webpack_public_path__ + "static/media/sample-manager-guide.3744a550.pdf";